<template>
  <div class="organisation">
    <sweet-modal title="GENERAL LEDGER (Organisation)" blocking width="1140" ref="modal" v-on:close="closeModal">

      <div class="organisation__header">
        <el-select v-model="filter.filterBy" placeholder="Filter" clearable filterable style="margin-right: 20px;">
          <el-option v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>

        <el-select disabled v-model="filter.filterBy2" placeholder="Filter 2" clearable filterable style="margin-right: 20px;">
          <el-option v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value">
          </el-option>
        </el-select>

        <el-dropdown>
          <el-button>
            Report Action <i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item>Download Pdf</el-dropdown-item>
            <el-dropdown-item>Upload Excel</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <el-table
        :data="tableData"
        border
        style="width: 100%">
        <el-table-column
          prop="name"
          label="">
          <template slot-scope="scope">
            {{scope.row.name}}
          </template>
        </el-table-column>
        <el-table-column
          prop="debit"
          label="Debit"
          width="180">
          <template slot-scope="scope">
            {{scope.row.debit}}
          </template>
        </el-table-column>
        <el-table-column
          prop="credit"
          label="Credit"
          width="180">
          <template slot-scope="scope">
            {{scope.row.credit}}
          </template>
        </el-table-column>
      </el-table>

    </sweet-modal>
  </div>
</template>

<script>
import {SweetModal} from "@totalflow4/tfsweet-modal-vue";

export default {
  name: "g-l-a-organisation",
  components: {
    SweetModal
  },
  props: {
    currencyList: {
      type: Array,
      default: () => ([])
    },
    startDate: {
      type: String,
      default: null,
    },
    endDate: {
      type: String,
      default: null,
    },
    options: {
      type: Array,
      default: () => ([])
    }
  },
  data() {
    return {
      filter: {
        filterBy: null,
        filterBy2: null
      },
      tableData: [],
    }
  },
  methods: {
    openModal(params) {
      this.$refs.modal.open()
    },
    closeModal(){},
  }
}
</script>

<style lang="scss" scoped>
.sweet-modal-overlay{
  z-index:1000;
}

.organisation {
  &__header {
    display: flex;
    justify-content: flex-end;
    margin-bottom: 20px;
  }
}
</style>
